import { render } from "./SettlementAdvanceTab.vue?vue&type=template&id=463a240c&scoped=true"
import script from "./SettlementAdvanceTab.vue?vue&type=script&lang=js"
export * from "./SettlementAdvanceTab.vue?vue&type=script&lang=js"

import "./SettlementAdvanceTab.vue?vue&type=style&index=0&id=463a240c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463a240c"]])

export default __exports__